import React from 'react';
import { formatTravelLeg, formatTravelLegList } from 'selectors/travel.selectors';
import { formatDateTime } from 'library/time';
import { getActiveIcon } from 'library/helpers';
import RouteLegInput from './input';

const config = {
  // List Table
  list: {
    // Table Columns
    format: formatTravelLegList,
    columns: [
      {
        title: 'Reference',
        dataIndex: 'reference_number',
        width: '300px',
        sorter: true
      },
      {
        title: 'Carrier',
        dataIndex: 'carrier',
        width: '210px',
        sorter: true,
        render: (text, record) => record.carrier
      },
      {
        title: 'Departure Time',
        dataIndex: 'departure_time',
        width: '330px',
        sorter: true,
        render: (text, record) => formatDateTime(record.departure_time, 'HH:mm')
      },
      {
        title: 'Arrival Time',
        dataIndex: 'arrival_time',
        width: '240px',
        sorter: true,
        defaultSortOrder: 'ascend',
        render: (text, record) => formatDateTime(record.arrival_time, 'HH:mm')
      },
      {
        title: 'Active',
        dataIndex: 'active',
        width: '240px',
        sorter: true,
        render: (text, record) => getActiveIcon(record.active)
      }
    ],
    // Deleting
    confirmMessage: () => (
      <div>
        <p>
          Are you sure you wish to delete the leg with this route ?
        </p>
        <p>
          This action cannot be undone.
        </p>
      </div>
    ),
    // Filtering
    sorter: {
      field: 'reference',
      order: 'ascend'
    },
    filters: {},
    customFilters: {
      reference_number: {
        filterDropdownVisible: false,
        filtered: false,
        contains: true,
        searchFields: ['reference_number'],
        searchValue: ''
      },
      carrier: {
        filterDropdownVisible: false,
        filtered: false,
        contains: true,
        searchFields: ['carrier'],
        searchValue: ''
      }
    },
    // General
    title: 'Legs',
    commands: {
      showDelete: false,
      showAdd: false
    }
  },
  // Detail Screen
  detail: {
    // General
    format: formatTravelLeg,
    emptyMessage: 'Please select a Route',
    title: 'Leg',
    component: props => (
      <RouteLegInput
        {...props}
        title="Leg"
        inputFormItemLayout={{
          inputLayout: {
            labelCol: {
              xs: { span: 24 },
              sm: { span: 8 }
            },
            wrapperCol: {
              xs: { span: 24 },
              sm: { span: 16 }
            }
          },
          row: {
            gutter: 16
          },
          col: {
            span: 12
          }
        }}
      />
    )
  }
};

export default config;
